export default "__VITE_ASSET__55bbad67__"